var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drawing"},[_c('h6',{staticClass:"title"},[_vm._v("Product Data Drawing")]),_c('div',{staticClass:"images"},[_c('img',{attrs:{"src":_vm.products.connectors[0].drawingImage}}),_c('img',{attrs:{"src":_vm.products.connectors[1].drawingImage}})]),_c('data',{staticClass:"calculation"},[_vm._v(_vm._s(_vm.calculation[0]))])])
}
var staticRenderFns = []

export { render, staticRenderFns }